import React from "react";

/**
 * 汎用画像コンポーネント
 * @param {object} props
 * @param {string} props.src - 画像URL
 * @param {string} props.alt - 代替テキスト
 * @param {string} [props.className] - 追加クラス
 * @param {object} [props.style] - インラインスタイル
 */
const Image = ({ src, alt, className, style = {} }) => (
  <img src={src} alt={alt} { ...(className && { className }) } style={style} />
);

export default Image; 